import { createGlobalStyle } from 'styled-components';

export const HelperStyles = createGlobalStyle`
  .WrapperSc {
  }

  .dF{
    display: flex
  }

  .dIF{
    display: inline-flex
  }

  .flexWrap{
    flex-wrap: wrap
  }

  .width100 {
    width:100%;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flexCol {
    display: flex;
    flex-direction: column;
  }

  .justifyCenter {
    justify-content: center;
  }

  .justifyStart {
    justify-content: flex-start;
  }

  .justifyEnd {
    justify-content: flex-end;
  }

  .justifyBetween{
    justify-content: space-between;
  }

  .justifyAround{
    justify-content: space-around;
  }

  .alignItemsCenter{
    align-items: center;
  }

  .alignItemsStart{
    align-items: flex-start;
  }

  .alignItemsEnd{
    align-items: flex-end;
  }

  .alignItemsBaseline{
    align-items: baseline;
  }

  .alignItemsStretch{
    align-items: stretch;
  }

  .alignSelfStart{
    align-self: flex-start;
  }

  .alignSelfCenter{
    align-self: center;
  }

  .fGS0{
    flex-grow: 0;
    flex-shrink: 0;
  }

  .black{
    color: #141823;
  }

  .drGrey{
    color: #777777;
  }

  .greyLt {
    color: #dadee3
  }

  .pinkish_orange {
    color: #ff6d38;
  }

  .white {
    color: #ffffff;
  }

  .red {
    color: #ff0000;
  }

  .txtUpper {
    text-transform: uppercase;
  }

  .fn {
    font-weight: normal;
  }
  .{
    font-size: 1.1rem;
    line-height: inherit;
  }

  .{
    font-size: 1.2rem;
    line-height: inherit;
  }

  .font13 {
    font-size: 13px;
    line-height: inherit;
  }

  .font14 {
    font-size: 14px;
  }

  .padT5 {
    padding-top: 0.5rem;
  }

  .padB5 {
    padding-bottom: 0.5rem;
  }

  .padL5 {
    padding-left: 0.5rem;
  }

  .padR5 {
    padding-right: 0.5rem;
  }

  .txtRight {
    text-align: right;
  }

  .txtCenter {
    text-align: center;
  }

  .padT10 {
    padding-top: 10px;
  }

  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;
  }

  .width48 {
    width: 48%;
  }

  .width50 {
    width: 50%;
  }

  .width80 {
    width: 90%;
  }

  .light_grey {
    color: #c2c2c2
  }

  .padB10 {
    padding-bottom: 10px;
  }

  .pad20 {
    padding:2rem;
  }

  .brdrBot {
    border-bottom: 1px solid #F0F0F0;
  }

  .posRel {
    position:relative;
  }
  .lineHeight14{
    line-height: 14px;
  }
`;
